export default "__VITE_ASSET__cd7ae13f__"